import axios from 'axios';
import isEqual from 'lodash-es/isEqual';

import { APIWithoutToken } from './api';
import { getAPICachingTime, returnAPICachingHeader } from '../../helpers/helpers';
import { cachingHigh } from '../../data/webPageData';

const cancelTokens = [];
const caches = {
  searchDomains: [],
};

export const getDomains = async (params) => {
  const { CancelToken } = axios;
  const cancelDomainsReqObj = CancelToken.source();
  cancelTokens.push(cancelDomainsReqObj);

  const cachedItems = caches.searchDomains.find((cache) => isEqual(cache.params, params));
  if (cachedItems && cachedItems.expDate > Date.now()) {
    return cachedItems.response;
  }

  // here used axios cancel methods to cancel requests if user sends new one
  const res = await APIWithoutToken.get('domains/search', {
    cancelToken: cancelDomainsReqObj.token,
    params,
    headers: {
      'Cache-control': returnAPICachingHeader(cachingHigh),
    },
  });

  caches.searchDomains.unshift({
    params,
    expDate: getAPICachingTime(cachingHigh),
    response: res,
  });

  return res;
};

export const cancelPendingDomainRequests = () => {
  while (cancelTokens.length) {
    cancelTokens.shift().cancel();
  }
};
